// import React from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';
// import { Leaf, Zap, RefreshCw, Palette } from 'lucide-react';

// const features = [
//   {
//     icon: Leaf,
//     title: 'Eco-Friendly',
//     description: 'No paper, fully digital',
//     color: 'from-green-500 to-emerald-500',
//   },
//   {
//     icon: Zap,
//     title: 'Instant Sharing',
//     description: 'NFC, QR, or link',
//     color: 'from-yellow-500 to-orange-500',
//   },
//   {
//     icon: RefreshCw,
//     title: 'Always Updated',
//     description: 'Real-time edits',
//     color: 'from-blue-500 to-cyan-500',
//   },
//   {
//     icon: Palette,
//     title: 'Professional Branding',
//     description: 'Custom designs',
//     color: 'from-purple-500 to-pink-500',
//   },
// ];

// export function WhyChoose() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   return (
//     <section className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20">
//       <div className="max-w-7xl mx-auto">
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-16"
//         >
//           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
//             Why Choose{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               Digital Business Cards?
//             </span>
//           </h2>
//         </motion.div>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
//           {features.map((feature, index) => (
//             <motion.div
//               key={feature.title}
//               initial={{ opacity: 0, y: 40 }}
//               animate={inView ? { opacity: 1, y: 0 } : {}}
//               transition={{ delay: index * 0.1 + 0.2, duration: 0.6 }}
//               whileHover={{ y: -8, scale: 1.02 }}
//               className="group relative"
//             >
//               <div className="relative bg-card border border-border rounded-2xl p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
//                 {/* Gradient Border on Hover */}
//                 <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/0 to-accent/0 group-hover:from-primary/20 group-hover:to-accent/20 transition-all duration-300" />

//                 <div className="relative">
//                   {/* Icon */}
//                   <motion.div
//                     className={`w-14 h-14 rounded-xl bg-gradient-to-br ${feature.color} p-3 mb-4 shadow-lg`}
//                     whileHover={{ scale: 1.1, rotate: 5 }}
//                     transition={{ type: 'spring', stiffness: 300 }}
//                   >
//                     <feature.icon className="w-full h-full text-white" />
//                   </motion.div>

//                   {/* Content */}
//                   <h3 className="text-xl font-bold text-foreground mb-2">
//                     {feature.title}
//                   </h3>
//                   <p className="text-muted-foreground">
//                     {feature.description}
//                   </p>
//                 </div>

//                 {/* Glow Effect */}
//                 <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl bg-gradient-to-br from-primary/10 to-accent/10 -z-10" />
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }





import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Leaf, Zap, RefreshCw, Palette } from "lucide-react";

const features = [
  {
    icon: Leaf,
    title: "Eco-Friendly",
    description: "No paper, fully digital",
    gradient: "linear-gradient(135deg, #22c55e, #10b981)",
  },
  {
    icon: Zap,
    title: "Instant Sharing",
    description: "NFC, QR, or link",
    gradient: "linear-gradient(135deg, #facc15, #f97316)",
  },
  {
    icon: RefreshCw,
    title: "Always Updated",
    description: "Real-time edits",
    gradient: "linear-gradient(135deg, #3b82f6, #22d3ee)",
  },
  {
    icon: Palette,
    title: "Professional Branding",
    description: "Custom designs",
    gradient: "linear-gradient(135deg, #a855f7, #ec4899)",
  },
];

const WhyChoose = () => {
  const [inView, setInView] = useState(false);

  // simple scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("why-choose");
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setInView(true);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="why-choose" style={{ padding: "80px 16px", backgroundColor: "#ffffff", }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", }}>
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          style={{ textAlign: "center", marginBottom: "64px", }}
        >
          <h2 style={{ fontSize: "2.75rem", fontWeight: "bold", color: "#111", lineHeight: 1.2, }}>
            Why Choose{" "}
            <span style={{ background: "linear-gradient(to right, #6366f1, #22d3ee)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", }}>
              Digital Business Cards?
            </span>
          </h2>
        </motion.div>

        {/* Cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "24px", }}>
          {features.map((feature, index) => {
            const Icon = feature.icon;

            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: index * 0.15 + 0.2, duration: 0.6 }}
                whileHover={{ y: -8, scale: 1.03 }}
                style={{
                  background: "#ffffff",
                  borderRadius: "24px",
                  padding: "32px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Glow */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(135deg, rgba(99,102,241,0.08), rgba(34,211,238,0.08))",
                    opacity: 0,
                    transition: "opacity 0.3s",
                  }}
                  className="card-glow"
                />

                {/* Icon */}
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "14px",
                    background: feature.gradient,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                  }}
                >
                  <Icon color="#fff" size={28} />
                </motion.div>

                {/* Text */}
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "bold",
                    color: "#111",
                    marginBottom: "8px",
                  }}
                >
                  {feature.title}
                </h3>

                <p
                  style={{
                    fontSize: "1rem",
                    color: "#6b7280",
                  }}
                >
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;

